import {SUMMARY_PAYMENTS_STATUSES} from '@chekin/core';
import {useSummary} from 'context/summary';

const PAYMENT_STEPS = [
  {
    kind: 'booking_payments',
    title: 'welcome_step_reservation_payment',
    hint: 'welcome_step_reservation_payment_hint',
  },
  {
    kind: 'taxes',
    title: 'welcome_step_tourist_tax',
    hint: 'welcome_step_tourist_tax_hint',
  },
  {
    kind: 'property_protection',
    title: 'welcome_step_deposit',
    hint: 'welcome_step_deposit_hint',
  },
] as const;

export function usePendingPaymentSteps() {
  const {data: summary} = useSummary();

  return PAYMENT_STEPS.filter(step => {
    const payment = summary?.[step.kind];
    return payment?.active && payment.status !== SUMMARY_PAYMENTS_STATUSES.complete;
  });
}
